import { render, staticRenderFns } from "./addSettled.vue?vue&type=template&id=fb8896e6&scoped=true&"
import script from "./addSettled.vue?vue&type=script&lang=js&"
export * from "./addSettled.vue?vue&type=script&lang=js&"
import style0 from "./addSettled.vue?vue&type=style&index=0&id=fb8896e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8896e6",
  null
  
)

export default component.exports